'use client'

const STUDIO_BASE_URL = process.env.NEXT_PUBLIC_STUDIO_CF_URL ?? ''

interface FeaturedTemplateItemProps {
  name: string
  thumbnailUrl: string | undefined
  'data-card'?: true
}

export function FeaturedTemplateItem({ name, thumbnailUrl, ...rest }: FeaturedTemplateItemProps) {
  return (
    <div className="shrink-0 w-[130px] lg:w-[160px] snap-center" {...rest}>
      <a
        href={`${STUDIO_BASE_URL}/ai-video-generator`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={name}
        className="group relative block aspect-[190/285] w-full overflow-hidden rounded-sm border border-cf-sf-gray-350/40 bg-cf-grey-200 focus-visible:ring-2 focus-visible:ring-cf-green focus-visible:outline-none"
      >
        {thumbnailUrl ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            src={thumbnailUrl}
            alt=""
            loading="lazy"
            className="size-full object-cover transition-transform duration-200 group-hover:scale-105"
          />
        ) : null}
        <div className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-cf-black/70 to-transparent p-2">
          <span className="text-sm font-semibold font-poppins text-cf-white line-clamp-1">
            {name}
          </span>
        </div>
      </a>
    </div>
  )
}
